module.exports = __webpack_public_path__ + "img/200-f0a9c9.png";